<script>
    import {onDestroy} from 'svelte';
    import R, {LOADER} from "../lib/requests";
    import app from "../stores/app";
    import members from "../stores/members";
    import {setFocusTo, isNumeric, upCaseStr} from "../lib/lib";
    import Notifier from "../stores/notifier";
    import Alert from "../stores/alerts";
    import PageHeader from "../components/PageHeader.svelte";
    import Breadcrumb from "../components/Breadcrumb.svelte";
    import Tabs from "../components/tabs/Tabs.svelte";
    import CodeControl from "../components/controls/CodeControl.svelte";
    import Checkbox from "../components/controls/Checkbox.svelte";
    import AutocompleteControl from "../components/controls/AutocompleteControl.svelte";
    import PhoneControl from "../components/controls/PhoneControl.svelte";
    import Subscriptions from "./Subscriptions.svelte";
    import PageNotFound from "../components/pages/PageNotFound.svelte";

    export let memberId = null;

    const breadcrumb = [
        {id: 'members', name: 'Μέλη', link: `/app/members`}
    ];

    let pageHeaderControls = [
        {id: 'save', name: 'ΕΝΗΜΕΡΩΣΗ', tip: 'ενημέρωση μέλους', class: 'hidden-xs'},
        {
            id: 'save',
            name: '',
            tip: 'ενημέρωση μέλους',
            icon: 'save',
            class: 'hidden-xl hidden-lg hidden-md hidden-sm'
        },
    ];

    const occupationTypes = ['', 'ΔΗΜΟΣΙΟ', 'ΙΔΙΩΤΗΣ', 'ΜΙΣΘΩΤΟΣ'];

    const upCaseFields = () => {
        let fields = ['lastname', 'firstname', 'doy', 'address', 'city', 'university', 'university_branch', 'rationale'];

        fields.map(key => {
            member[key] = upCaseStr(member[key]);
        });
    }

    let member = null;
    let pageTitle = '';
    let changePassword = false;
    let sendAccountActivationMail = 0;
    let unloadEventInitialized = false;


    const initialize = () => {
        if (memberId == 0) {
            member = {
                id: 0,
                code: '',
                lastname: '',
                firstname: '',
                email: '',
                password: '',
                phone1: '',
                phone2: '',
                mobile: '',
                afm: '',
                doy: '',
                occupation_type: 0,
                birthday: null,
                birth_place: '',
                address: '',
                city: '',
                post_code: '',
                region_id: 0,
                university: '',
                university_branch: '',
                graduated_at: null,
                registration_year: null,
                rationale: '',
                vat_regime_id: $app.vat_regimes[0].id,
                notes: '',
                is_verified: 1,
                status_id: 0,
                subscriptions: [],
            };
            $members.memberIsDirty = false;
            pageTitle = "Νέο μέλος";
            setFocusTo("memberCode");
        } else {
            pageTitle = "Στοιχεία Μέλους";
            load();
        }
    }

    const load = () => {
        const onSuccess = result => {
            member = result;
            member.occupation_type = Number(member.occupation_type);
            member.status_id = Number(member.status_id);
            initializeSubscriptions();
            $members.memberIsDirty = false;
            setFocusTo("memberLastname");
        }

        const onFailure = err => {
            if (err.code && err.code === 'not_found') {
                memberId = -1;
            }
        };

        R.handle(R.member.details, memberId, onSuccess, onFailure, LOADER.PAGE);
    }


    const save = () => {
        const onSuccess = result => {
            member = result;
            memberId = result.id;
            changePassword = false;
            delete (member.new_password);
            initializeSubscriptions();
            $members.memberIsDirty = false;
            $members.changed = true;
            setPageHeaderControls();
            pageTitle = "Στοιχεία Μέλους";
            Notifier.showMessage("Το μέλος ενημερώθηκε");

            if (sendAccountActivationMail == 1) {
                sendActivationMail();
            }
        }

        const onFailure = err => {
            let message = "";
            let focusField = "";

            if (err.code) {
                if (err.code === 'same_object_identifier') {
                    if (err.params.field === 'code') {
                        message = `Υπάρχει ήδη ένα μέλος με αρ. μητρώου ${member.code}.`;
                        focusField = "memberCode";
                    }
                    if (err.params.field === 'afm') {
                        message = `Υπάρχει ήδη ένα μέλος με ΑΦΜ ${member.afm}.`;
                        focusField = "memberAfm";
                    }
                }
            }

            if (!message) {
                message = err.message;
            }

            Alert.warning("Ενημέρωση μέλους", message, () => {
                if (focusField) {
                    setFocusTo(focusField);
                }
            });
        };

        member.code = member.code ? member.code.trim() : '';
        if (!member.code) {
            Notifier.showError("Συμπληρώστε τον αριθμό μητρώου του μέλους!");
            setFocusTo("memberCode");
            return;
        }

        member.lastname = member.lastname.trim();
        if (!member.lastname) {
            Notifier.showError("Συμπληρώστε το επίθετο του μέλους!");
            setFocusTo("lastName");
            return;
        }

        if (member.post_code && !isNumeric(member.post_code)) {
            Notifier.showError("Ο ταχυδρομικός κώδικας πρέπει να είναι αριθμός!");
            setFocusTo("postCode");
            return;
        }

        member.email = member.email.trim();
        if (member.status_id == 1 && !member.email) {
            Alert.warning("Λογαριασμός μέλους", "Για να ενεργοποιήσετε τον λογαριασμό του μέλους πρέπει να εισάγετε το email που θα χρησιμοποιεί το μέλος για την είσοδο στον λογαριασμό του.", () => {
                setFocusTo('memberEmail');
            });
            return;
        }

        let action = memberId == 0 ? 'create' : 'edit';
        R.handle(R.member[action], member, onSuccess, onFailure, LOADER.POPUP);
    }

    const sendActivationMail = () => {
        const onSuccess = result => {
            sendAccountActivationMail = 0;
            Notifier.showMessage("Το μέλος ενημερώθηκε για την ενεργοποίηση του λογαριασμού του");
        }

        const onFailure = err => {
            Alert.warning("Αποστολή Email", "Δεν ήταν δυνατή η αποστολή email στο μέλος!");
        };

        R.handle(R.member.activationMail, member.id, onSuccess, onFailure, LOADER.POPUP);
    }

    const initializeSubscriptions = () => {
        let index = 0;
        member.subscriptions.map(item => {
            item.index = index;
            index++;
        });
    }

    const togglePassword = () => {
        changePassword = !changePassword;
    }

    const onDataChange = (event) => {
        upCaseFields();
        $members.memberIsDirty = true;
        setPageHeaderControls();
    }

    const onStatusChange = () => {
        if (member.id == 0) {
            member.is_verified = 1;
        }
    }

    const setPageHeaderControls = () => {
        pageHeaderControls.map(item => {
            if (item.id === 'save') {
                item.active = $members.memberIsDirty;
            }
        });
        pageHeaderControls = pageHeaderControls;
    }

    const beforeUnloadListener = (event) => {
        event.preventDefault();
        return (event.returnValue = "");
    };

    // const unloadEventHandler = (event) => {
    //     event.preventDefault();
    //     event.returnValue = '';
    // }

    onDestroy(() => {
        $members.memberIsDirty = false;
        removeEventListener("beforeunload", beforeUnloadListener, {capture: true});
    });

    initialize();

    $: {
        // handle browser refresh or close events
        if ($members.memberIsDirty && !unloadEventInitialized) {
            addEventListener("beforeunload", beforeUnloadListener, {capture: true});
            unloadEventInitialized = true;
            setPageHeaderControls();
        } else if (!$members.memberIsDirty && unloadEventInitialized) {
            removeEventListener("beforeunload", beforeUnloadListener, {capture: true});
            unloadEventInitialized = false;
            setPageHeaderControls();
        }
    }
</script>

<Breadcrumb {breadcrumb}/>
<PageHeader title="{ pageTitle }" controls={ pageHeaderControls } sticky on:save={ save }/>
{#if member}
    <div class="row">
        <div class="col-xl-6">
            <Tabs titles={['ΓΕΝΙΚΑ', 'ΠΡΟΣΩΠΙΚΑ - ΣΠΟΥΔΕΣ']} cssClass="mb-5">
                <div slot="tab1">
                    <div class="form-group">
                        <label>Αρ. Μητρώου</label>
                        <CodeControl id="memberCode" bind:value="{ member.code }" style="max-width: 130px;"
                                     on:change={ onDataChange }/>
                    </div>
                    <div class="row">
                        <div class="col-xl-6 form-group">
                            <label>Επίθετο</label>
                            <input type="text" class="form-control" id="lastName"
                                   bind:value="{ member.lastname }"
                                   on:change={ onDataChange }>
                        </div>
                        <div class="col-xl-6 form-group">
                            <label>Όνομα</label>
                            <input type="text" class="form-control" bind:value="{ member.firstname }"
                                   on:change={ onDataChange }>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-4 form-group">
                            <label>Τηλέφωνο 1</label>
                            <PhoneControl bind:value="{ member.phone1 }" on:change={ onDataChange }/>
                        </div>
                        <div class="col-xl-4 form-group">
                            <label>Τηλέφωνο 2</label>
                            <PhoneControl bind:value="{ member.phone2 }" on:change={ onDataChange }/>
                        </div>
                        <div class="col-xl-4 form-group">
                            <label>Κινητό</label>
                            <PhoneControl bind:value="{ member.mobile }" on:change={ onDataChange }/>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-xl-3 form-group">
                            <label>Α.Φ.Μ.</label>
                            <input type="text" class="form-control" id="memberAfm" bind:value="{ member.afm }"
                                   on:change={ onDataChange }>
                        </div>
                        <div class="col-xl-3 form-group">
                            <label>ΔΟΥ</label>
                            <input type="text" class="form-control" bind:value="{ member.doy }"
                                   on:change={ onDataChange }>
                        </div>
                        <div class="col-xl-3 form-group">
                            <label>Καθεστώς Φ.Π.Α.</label>
                            <select class="form-select" bind:value="{ member.vat_regime_id }"
                                    on:change={ onDataChange }>
                                {#each $app.vat_regimes as item}
                                    <option value="{ item.id }">{ item.name } ({ item.vat }%)</option>
                                {/each}
                            </select>
                        </div>
                        <div class="col-xl-3 form-group">
                            <label>Είδος απασχ.</label>
                            <select class="form-select" bind:value={member.occupation_type}
                                    on:change={onDataChange}>
                                {#each occupationTypes as type, index}
                                    <option value={index}>{type}</option>
                                {/each}
                            </select>
                        </div>
                    </div>
                    <hr>
                    <div class="form-group">
                        <label>Διεύθυνση</label>
                        <input type="text" class="form-control" bind:value="{ member.address }"
                               on:change={ onDataChange }>
                    </div>
                    <div class="row">
                        <div class="col-xl-6 form-group">
                            <label>Πόλη</label>
                            <AutocompleteControl object="city" id="city" bind:value="{ member.city }"
                                                 on:change={ onDataChange }/>
                        </div>
                        <div class="col-xl-2 form-group">
                            <label>Τ.Κ.</label>
                            <input type="text" class="form-control" id="postCode" bind:value="{ member.post_code }"
                                   maxlength="5"
                                   oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
                                   on:change={ onDataChange }>
                        </div>
                        <div class="col-xl-4 form-group">
                            <label>Νομός</label>
                            <select class="form-select" id="regionId" bind:value="{ member.region_id }"
                                    on:change={ onDataChange }>
                                <option value="0" disabled selected>επιλογή νομού</option>
                                {#each $app.regions as region}
                                    <option value="{ region.id }">{ region.name }</option>
                                {/each}
                            </select>
                        </div>
                    </div>
                </div>

                <div slot="tab2">
                    <div class="row">
                        <div class="col-xl-3 form-group">
                            <label>Έτος εγγραφής</label>
                            <input type="number" class="form-control" bind:value="{ member.registration_year }"
                                   on:change={onDataChange}>
                        </div>
                        <div class="col-xl-9 form-group">
                            <label>Αιτιολογία</label>
                            <input type="text" class="form-control" bind:value="{ member.rationale }"
                                   on:change={onDataChange}>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-xl-3 form-group">
                            <label>Ημ. Γέννησης</label>
                            <input type="date" class="form-control" bind:value="{ member.birthday }"
                                   on:change={ onDataChange }>
                        </div>
                        <div class="col-xl-9 form-group">
                            <label>Τόπος Γέννησης</label>
                            <input type="text" class="form-control" bind:value="{ member.birth_place }"
                                   on:change={ onDataChange }>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-xl-5 form-group">
                            <label>Πανεπιστήμιο</label>
                            <AutocompleteControl object="university" id="university" bind:value="{ member.university }"
                                                 on:change={ onDataChange }/>
                        </div>
                        <div class="col-xl-4 form-group">
                            <label>Παράρτημα</label>
                            <AutocompleteControl object="university_branch" id="universityBranch"
                                                 bind:value="{ member.university_branch }" on:change={ onDataChange }/>
                        </div>
                        <div class="col-xl-3 form-group">
                            <label>Ημ. Αποφοίτησης</label>
                            <input type="date" class="form-control" bind:value="{ member.graduated_at }"
                                   on:change={ onDataChange }>
                        </div>
                    </div>
                </div>
            </Tabs>
        </div>
        <div class="col-xl-4">
            <div class="panel panel-default mb-4">
                <div class="panel-heading">
                    Λογαριασμός
                </div>
                <div class="panel-body panel-pad">
                    <div class="form-group">
                        <label>Email</label>
                        <input type="email" id="memberEmail" class="form-control" bind:value="{ member.email }"
                               on:change={ onDataChange }>
                    </div>
                    {#if member.status_id > 0}
                        {#if member.id == 0}
                            <div class="form-group">
                                <label>Κωδικός</label>
                                <input type="text" class="form-control" bind:value="{ member.password }">
                            </div>
                        {:else}
                            {#if !changePassword}
                                <button class="btn btn-link ps-0" on:click={ togglePassword }>Αλλαγή κωδικού</button>
                            {:else}
                                <div class="form-group mb-0">
                                    <label>Νέος κωδικός</label>
                                    <input type="text" class="form-control" bind:value="{ member.new_password }">
                                    <button class="btn btn-link ps-0" on:click={ togglePassword }>
                                        Χωρίς αλλαγή κωδικού
                                    </button>
                                </div>
                            {/if}
                        {/if}
                    {/if}
                    <hr class="mt-0">
                    <div class="form-group">
                        <label>Κατάσταση</label>
                        <select class="form-select" bind:value={member.status_id} on:change={ onDataChange }>
                            <option value={0}>Δεν χρησιμοποιείται από το μέλος</option>
                            <option value={1}>Ενεργός λογαριασμός</option>
                            <option value={2}>Απενεργοποιημένος λογαριασμός</option>
                        </select>
                    </div>
                    {#if member.status_id > 0}
                        <div class="form-group">
                            <Checkbox label="Πιστοποιημένος λογαριασμός" bind:checked={ member.is_verified }
                                      on:change={ onDataChange }/>
                            <p class="small text-gray mt-1">Μόνο τα επαληθευμένα μέλη μπορούν να αγοράσουν προϊόντα με
                                κάρτα.</p>
                        </div>
                    {/if}
                    <!--                    <div class="form-group">-->
                    <!--                        <Checkbox label="Έχει πρόσβαση στα έγγραφα" bind:checked={ member.can_access_documents }/>-->
                    <!--                        <p class="small mt-2 ps-4 text-gray line-height-1">-->
                    <!--                            Αν δεν είναι τσεκαρισμένο, στην είσοδο του μέλους θα εμφανίζεται η ειδοποίηση για την-->
                    <!--                            τακτοποίηση οφειλών και δεν θα έχει πρόσβαση στα έγγραφα.-->
                    <!--                        </p>-->
                    <!--                    </div>-->
                    <!--{#if member.email && member.is_active}-->
                    <!--    <hr class="mt-0">-->
                    <!--    <div class="form-group">-->
                    <!--        <Checkbox label="Να σταλεί ειδοποίηση στο μέλος για την ενεργοποίηση του λογαριασμού του"-->
                    <!--                  bind:checked="{ sendAccountActivationMail }"-->
                    <!--        />-->
                    <!--        {#if member.can_access_documents == 0}-->
                    <!--            <p class="small mt-2 ps-4 text-gray line-height-1">-->
                    <!--                Η ειδοποίηση θα περιλαμβάνει και το κείμενο για την τακτοποίηση οφειλών.-->
                    <!--            </p>-->
                    <!--        {/if}-->
                    <!--    </div>-->
                    <!--{/if}-->
                </div>
            </div>

            <Subscriptions bind:subscriptions={ member.subscriptions } on:change={ onDataChange }/>
            <textarea class="form-control" style="height:123px;" bind:value="{ member.notes }"
                      placeholder="Σημειώσεις"></textarea>
        </div>
    </div>
{/if}
{#if memberId == -1}
    <PageNotFound message="Το μέλος δεν βρέθηκε!"/>
{/if}

